// 측정기 교정기기 목록
import moment from 'moment';
const strDt = moment().startOf('month').format('YYYY-MM-DD');
const endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {
	isMmcAdmin: false,
	isMmcGuest: false,
	eqipDtlCdList: [], //장비 selectBox
	eqipKndCdList: [], //장비종류 selectBox
	calStCdList: [], //교정상태 selectBox
	runStCdList: [], //가동상태 selectBox
	calWayCdList: [], //교정방식 selectBox
	calCyclCdList: [], //교정주기 selectBox
	calRsltCdList: [], //교정결과 selectBox
	runStCdList: [], //가동상태 selectBox
	ynCdList: [], //보고서유무 selectBox
	usePlCdList: [], //사용장소 selectBox
	sndStCdList: [], //메일 발송상태 selectBox
	calInstCdList: [], //교정업체 selectBox
	utmCdList: [], //측정단위 selectBox

	resultList: [],
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		mesEqipNm: '', //장비명 or 관리번호
		calInstCd: '', //교정업체코드
		strDt,
		endDt
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 0
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
